import { Predicate } from "@siteimprove/alfa-predicate";
const { property } = Predicate;
export function hasAttribute(nameOrPredicate, value = () => true) {
    if (typeof nameOrPredicate === "function") {
        return (element) => element.attribute(nameOrPredicate).isSome();
    }
    const name = nameOrPredicate;
    const predicate = property("value", value);
    return (element) => element.attribute(name).some(predicate);
}
//# sourceMappingURL=has-attribute.js.map